/* ============================================================
   Eleve — Newsletter Popup
   - Delay trigger (configurable)
   - Exit-intent trigger (configurable, desktop only)
   - Whichever fires first wins
   - localStorage cooldown after dismiss
   - Success state if user submits
   - Closes on backdrop click, ×, ESC
   ============================================================ */

(function () {
  'use strict';

  var STORAGE_KEY_DISMISS = 'ev_popup_dismissed_at';
  var STORAGE_KEY_SUBMITTED = 'ev_popup_submitted';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var popup = document.getElementById('EvPopup');
    if (!popup) return;

    // ---- skip on cart/checkout/account pages (don't interrupt purchase flow) ----
    var path = window.location.pathname;
    if (popup.dataset.skipCart === 'true' && /^\/(cart|checkouts|account|password|challenge)(\/|$)/.test(path)) return;

    // ---- already submitted? never show again. ----
    if (localStorage.getItem(STORAGE_KEY_SUBMITTED) === '1') return;

    // ---- still in cooldown? skip. ----
    var dismissedAt = parseInt(localStorage.getItem(STORAGE_KEY_DISMISS) || '0', 10);
    var cooldownDays = parseInt(popup.dataset.cooldown || '30', 10);
    var cooldownMs = cooldownDays * 24 * 60 * 60 * 1000;
    if (dismissedAt && (Date.now() - dismissedAt) < cooldownMs) return;

    // ---- check URL for ?evpopup=1 (force-show, for testing/preview) ----
    var forceShow = /[?&]evpopup=1\b/.test(window.location.search);

    var delaySec = parseInt(popup.dataset.delay || '8', 10);
    var exitIntent = popup.dataset.exitIntent === 'true';

    var opened = false;
    var delayTimer = null;

    function openPopup() {
      if (opened) return;
      opened = true;

      // remove triggers
      if (delayTimer) clearTimeout(delayTimer);
      document.removeEventListener('mouseout', exitIntentHandler);

      popup.hidden = false;
      // force reflow then add class for transition
      void popup.offsetWidth;
      popup.classList.add('is-open');

      document.body.style.overflow = 'hidden';

      // focus first input for accessibility
      var emailInput = popup.querySelector('.ev-popup__email');
      if (emailInput) setTimeout(function () { emailInput.focus(); }, 280);
    }

    function closePopup(opts) {
      opts = opts || {};
      popup.classList.remove('is-open');
      document.body.style.overflow = '';

      setTimeout(function () {
        popup.hidden = true;
      }, 250);

      if (!opts.submitted) {
        try { localStorage.setItem(STORAGE_KEY_DISMISS, String(Date.now())); } catch (e) {}
      }
    }

    function exitIntentHandler(e) {
      // only fire when mouse leaves through the top of the viewport
      if (!e.toElement && !e.relatedTarget && e.clientY < 10) {
        openPopup();
      }
    }

    // ---- triggers ----
    if (forceShow) {
      openPopup();
    } else {
      if (delaySec >= 0) {
        delayTimer = setTimeout(openPopup, delaySec * 1000);
      }
      if (exitIntent && window.matchMedia('(min-width: 768px)').matches) {
        document.addEventListener('mouseout', exitIntentHandler);
      }
    }

    // ---- close handlers ----
    popup.addEventListener('click', function (e) {
      if (e.target.closest('[data-ev-close]')) closePopup();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !popup.hidden) closePopup();
    });

    // ---- form submit: Shopify customer form posts and reloads the page.
    // To show success inline without reload, we intercept and POST via fetch. ----
    var form = popup.querySelector('#EvPopupForm');
    var formWrap = popup.querySelector('[data-ev-form-wrap]');
    var successEl = popup.querySelector('[data-ev-success]');

    if (form && formWrap && successEl) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('.ev-popup__cta');
        var emailInput = form.querySelector('.ev-popup__email');
        if (!emailInput || !emailInput.value) return;

        if (btn) { btn.disabled = true; btn.dataset.originalText = btn.textContent; btn.textContent = '...'; }

        var fd = new FormData(form);
        fd.append('form_type', 'customer');
        fd.append('utf8', '✓');

        fetch('/contact', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } })
          .then(function () {
            // Shopify returns 302 redirect on success — we don't actually inspect status.
            // We optimistically show success.
            try { localStorage.setItem(STORAGE_KEY_SUBMITTED, '1'); } catch (e) {}
            formWrap.hidden = true;
            successEl.hidden = false;

            // auto-close after 4s
            setTimeout(function () { closePopup({ submitted: true }); }, 4000);
          })
          .catch(function () {
            if (btn) { btn.disabled = false; btn.textContent = btn.dataset.originalText || 'Prijavi se'; }
            alert('Nešto nije u redu. Pokušajte ponovo.');
          });
      });
    }
  });
})();
